import React from 'react';

export const InspectionIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M12.6818 5.30451V2L7.5079 2.01311L2.33398 2V8.40576C2.33398 10.989 6.6023 14.0772 7.5079 13.9985C7.80755 14.0247 8.47343 13.7035 9.23254 13.1724M11.077 10.399L13.6673 13.074M11.6963 7.60586C11.6963 9.40916 10.2116 10.871 8.3802 10.871C6.54877 10.871 5.06411 9.40916 5.06411 7.60586C5.06411 5.80256 6.54877 4.34069 8.3802 4.34069C10.2116 4.34069 11.6963 5.80256 11.6963 7.60586Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default InspectionIcon;
